<template>
  <div class="error-page">
    <i class="el-icon-error"></i>
    <h1>Unauthorized Access!</h1>
    <p>
      You are not allowed to access:
      <el-link :href="oldPath" v-text="oldPath"></el-link>. Please coordinate
      with your system administrator.
    </p>
  </div>
</template>
<script>
export default {
  name: "error_401",
  computed: {
    oldPath() {
      return `${window.location.origin}${this.$route.params.oldPath}`;
    }
  },
  mounted() {
    if (!this.$route.params.hasOwnProperty("oldPath")) {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="css" scoped>
.error-page * {
  color: #f56c6c;
}
.error-page {
  background: #fff;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.error-page i {
  font-size: 64px;
  margin-bottom: 20px;
}
</style>
